"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.qaSelectors = exports.makeQaSelector = exports.makeQa = exports.default = void 0;

var _mapValues = _interopRequireDefault(require("lodash/mapValues"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const makeQaSelector = qaStr => `[data-qa='${qaStr}']`;

exports.makeQaSelector = makeQaSelector;

const makeQa = (...strs) => strs.reduce((acc, str) => `${acc}.${str}`, "SiteVision");

exports.makeQa = makeQa;
const qa = {
  mediaCard: makeQa("MediaCard"),
  mediaCardCheckbox: makeQa("MediaCard", "Checkbox"),
  mediaCardSpinner: makeQa("MediaCard", "Spinner"),
  mediaCardTitle: makeQa("MediaCard", "Title"),
  mediaCardDeleteButton: makeQa("MediaCard", "DeleteButton"),
  mediaCardRemoveButton: makeQa("MediaCard", "RemoveButton"),
  simpleMediaCard: makeQa("SimpleMediaCard"),
  mediaUploadModal: makeQa("MediaUpload", "Modal"),
  mediaUploadDoneButton: makeQa("MediaUpload", "Modal", "DoneButton"),
  mediaUploadDropZone: makeQa("MediaUpload", "Modal", "DropZone"),
  media: makeQa("Media"),
  mediaDetailModal: makeQa("MediaDetail", "Modal"),
  mediaDetailActionButton: makeQa("MediaDetail", "ActionButton"),
  mediaDetailDetailsHeader: makeQa("MediaDetail", "Details", "Header"),
  mediaDetailToolbar: makeQa("MediaDetail", "Toolbar"),
  mediaDetailPageForwardButton: makeQa("MediaDetail", "Toolbar", "PageForwardButton"),
  mediaDetailPageBackButton: makeQa("MediaDetail", "Toolbar", "PageBackButton"),
  mediaDetailDetailsBody: makeQa("MediaDetail", "Details", "Body")
};
const qaSelectors = (0, _mapValues.default)(qa, makeQaSelector);
exports.qaSelectors = qaSelectors;
var _default = qa;
exports.default = _default;